import { LoginWidgetLinks } from 'module/authentication/types';
import { Layout } from 'module/ui/components/atoms/layout';
import {
  BodyShort01,
  ProductiveHeading03,
  ProductiveHeading05,
} from 'module/ui/components/styles';
import { Link } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as PaperplaneSVG } from './paper-plane.svg';

const Container = styled(Layout.Content)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 88px 120px;
  align-items: flex-start;
`;
const ContainerWithTopPadding = styled(Container)`
  padding-top: 200px;
`;
const BackAction = styled.div`
  ${BodyShort01};
`;

const Title = styled.h2`
  ${ProductiveHeading03};
  margin-top: var(--spacing-04);
  margin-bottom: var(--spacing-03);
`;
const PageTitle = styled(Title)`
  color: var(--black-100);
`;
const LinkText = styled.span`
  ${BodyShort01};
  margin-bottom: 0;
`;
const Description = styled.p`
  ${ProductiveHeading05};
  font-weight: var(--heading-2-weight);
`;

interface Props {
  email: string;
  links: LoginWidgetLinks;
}
export const ForgetPasswordSuccessPage: FC<Props> = ({ email, links }) => {
  return (
    <Layout>
      <ContainerWithTopPadding>
        <Space direction="vertical" size={16}>
          <PaperplaneSVG />
          <PageTitle>
            <FormattedMessage id="forgot_password.success" />
            <strong>{email}</strong>
            <br />
            <FormattedMessage id="forgot_password.success_msg" />
          </PageTitle>
          <Description>
            <FormattedMessage id="forgot_password.success_help" />
          </Description>
          <BackAction>
            <FormattedMessage
              id="forgot_password.back"
              values={{
                a: (chunks) => (
                  <Link to={links.loginUrl}>
                    <LinkText>{chunks}</LinkText>
                  </Link>
                ),
              }}
            />
          </BackAction>
        </Space>
      </ContainerWithTopPadding>
    </Layout>
  );
};
